import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'

import ENGTimesheetsFull from '../engineering/ENGTimesheetsFull.jsx'
import ASSIGNARTimesheetsFull from '../assignar/ASSIGNARTimesheetsFull.jsx'
import TRAFFIOTimesheetsFull from '../traffio/TRAFFIOTimesheetsFull.jsx'

import Button from '@mui/material/Button';

import EngineeringIcon from '@mui/icons-material/Engineering';
import GroupsIcon from '@mui/icons-material/Groups';
import TrafficIcon from '@mui/icons-material/Traffic';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import {useNavigate} from 'react-router-dom'

export default function ACCTimesheets() {

  const navigate = useNavigate()

  const [division, setDivision] = React.useState("engineering")
  const [bearerTokenAssignar, setBearerTokenAssignar] = React.useState("");

  const authoriseUserAssignar = async () => {
    ///Assignar/Auth

    // https://ic360portalbackend.azurewebsites.net/api/login
    await fetch('https://ic360portalbackend.azurewebsites.net/api/Assignar/auth', {
      method: 'GET',
      headers: {
        'Content-type': 'application/JSON',
      },
    })    
    .then(response => response.json())
    .then (data => {
      // console.log(data.token)
      setBearerTokenAssignar(data.token)
    })

  }

  React.useEffect(()=>{
    authoriseUserAssignar()
  },[])

  return (
    <>
      <Navbar />
      <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="default-page-wrapper">
      <div className ="page-buttons-bar page-buttons-bar-parent">
            <Button sx ={{color: "white"}} onClick={()=>{navigate('/')}}> <ArrowBackOutlinedIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> back</Button>
            <div className="page-function-buttons-container">
              <Button sx ={{color: "white"}} onClick={()=>{setDivision("engineering")}}> <EngineeringIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> Engineering</Button>
              <Button sx ={{color: "white"}} onClick={()=>{setDivision("traffio")}}> <GroupsIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> Traffio</Button>
              {/* <Button sx ={{color: "white"}} onClick={()=>{setDivision("assignar")}}> <TrafficIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> Assignar</Button> */}
            </div>
        </div>
        {division === "engineering" &&
          <ENGTimesheetsFull viewer="accounts"/>}

        {division === 'assignar' &&
          <ASSIGNARTimesheetsFull bearerToken={bearerTokenAssignar}/>
        }

        {
          division === "traffio" &&
          <TRAFFIOTimesheetsFull/>
        }
      </div>
      <Footer />
      </div>
    </>
  )
}
